import { type } from '@/utils/type'

///////////////////////
//Actions types

//////////////////////////////////////////////////////////////////
// USER
/////////////////////////////////////////////////////////////////
export const ADM_USER_REQUEST =  type('ADM_USER_REQUEST')
export const ADM_USER_ENSURE =  type('ADM_USER_ENSURE')

export const ADM_USER_DETAIL_REQUEST =  type('ADM_USER_DETAIL_REQUEST')
export const ADM_USER_DETAIL_ENSURE =  type('ADM_USER_DETAIL_ENSURE')

export const ADM_USER_SAVE_REQUEST =  type('ADM_USER_SAVE_REQUEST')
export const ADM_USER_DELETE_REQUEST =  type('ADM_USER_DELETE_REQUEST')

export const ADM_USER_SAVE_MEMBER_REQUEST =  type('ADM_USER_SAVE_MEMBER_REQUEST')

export const ADM_USER_RESET_STATUS =  type('ADM_USER_RESET_STATUS')

//////////////////////////////////////////////////////////////////
// MAIL_TEMPLATE
/////////////////////////////////////////////////////////////////
export const ADM_MAIL_TEMPLATE_REQUEST =  type('ADM_MAIL_TEMPLATE_REQUEST')
export const ADM_MAIL_TEMPLATE_ENSURE =  type('ADM_MAIL_TEMPLATE_ENSURE')

export const ADM_MAIL_TEMPLATE_DETAIL_REQUEST =  type('ADM_MAIL_TEMPLATE_DETAIL_REQUEST')
export const ADM_MAIL_TEMPLATE_DETAIL_ENSURE =  type('ADM_MAIL_TEMPLATE_DETAIL_ENSURE')

export const ADM_MAIL_TEMPLATE_SAVE_REQUEST =  type('ADM_MAIL_TEMPLATE_SAVE_REQUEST')
export const ADM_MAIL_TEMPLATE_DELETE_REQUEST =  type('ADM_MAIL_TEMPLATE_DELETE_REQUEST')

export const ADM_MAIL_TEMPLATE_RESET_STATUS =  type('ADM_MAIL_TEMPLATE_RESET_STATUS')

//////////////////////////////////////////////////////////////////
// MAIL_SKIN
/////////////////////////////////////////////////////////////////
export const ADM_MAIL_SKIN_REQUEST =  type('ADM_MAIL_SKIN_REQUEST')
export const ADM_MAIL_SKIN_ENSURE =  type('ADM_MAIL_SKIN_ENSURE')

export const ADM_MAIL_SKIN_DETAIL_REQUEST =  type('ADM_MAIL_SKIN_DETAIL_REQUEST')
export const ADM_MAIL_SKIN_DETAIL_ENSURE =  type('ADM_MAIL_SKIN_DETAIL_ENSURE')

export const ADM_MAIL_SKIN_SAVE_REQUEST =  type('ADM_MAIL_SKIN_SAVE_REQUEST')
export const ADM_MAIL_SKIN_DELETE_REQUEST =  type('ADM_MAIL_SKIN_DELETE_REQUEST')

export const ADM_MAIL_SKIN_RESET_STATUS =  type('ADM_MAIL_SKIN_RESET_STATUS')

//////////////////////////////////////////////////////////////////
// PISCINE
/////////////////////////////////////////////////////////////////
export const ADM_PISCINE_REQUEST =  type('ADM_PISCINE_REQUEST')
export const ADM_PISCINE_ENSURE =  type('ADM_PISCINE_ENSURE')

export const ADM_PISCINE_DETAIL_REQUEST =  type('ADM_PISCINE_DETAIL_REQUEST')
export const ADM_PISCINE_DETAIL_ENSURE =  type('ADM_PISCINE_DETAIL_ENSURE')

export const ADM_PISCINE_SAVE_REQUEST =  type('ADM_PISCINE_SAVE_REQUEST')
export const ADM_PISCINE_DELETE_REQUEST =  type('ADM_PISCINE_DELETE_REQUEST')

export const ADM_PISCINE_RESET_STATUS =  type('ADM_PISCINE_RESET_STATUS')

//////////////////////////////////////////////////////////////////
// ACTIVITY
/////////////////////////////////////////////////////////////////
export const ADM_ACTIVITY_REQUEST =  type('ADM_ACTIVITY_REQUEST')
export const ADM_ACTIVITY_ENSURE =  type('ADM_ACTIVITY_ENSURE')

export const ADM_ACTIVITY_DETAIL_REQUEST =  type('ADM_ACTIVITY_DETAIL_REQUEST')
export const ADM_ACTIVITY_DETAIL_ENSURE =  type('ADM_ACTIVITY_DETAIL_ENSURE')

export const ADM_ACTIVITY_SAVE_REQUEST =  type('ADM_ACTIVITY_SAVE_REQUEST')
export const ADM_ACTIVITY_DELETE_REQUEST =  type('ADM_ACTIVITY_DELETE_REQUEST')

export const ADM_ACTIVITY_RESET_STATUS =  type('ADM_ACTIVITY_RESET_STATUS')

export const ADM_ACTIVITY_SET_LIST =  type('ADM_ACTIVITY_SET_LIST')

//////////////////////////////////////////////////////////////////
// FORFAIT
/////////////////////////////////////////////////////////////////
export const ADM_FORFAIT_REQUEST =  type('ADM_FORFAIT_REQUEST')
export const ADM_FORFAIT_ENSURE =  type('ADM_FORFAIT_ENSURE')

export const ADM_FORFAIT_DETAIL_REQUEST =  type('ADM_FORFAIT_DETAIL_REQUEST')
export const ADM_FORFAIT_DETAIL_ENSURE =  type('ADM_FORFAIT_DETAIL_ENSURE')

export const ADM_FORFAIT_SAVE_REQUEST =  type('ADM_FORFAIT_SAVE_REQUEST')
export const ADM_FORFAIT_DELETE_REQUEST =  type('ADM_FORFAIT_DELETE_REQUEST')

export const ADM_FORFAIT_RESET_STATUS =  type('ADM_FORFAIT_RESET_STATUS')

//////////////////////////////////////////////////////////////////
// MNS
/////////////////////////////////////////////////////////////////
export const ADM_MNS_REQUEST =  type('ADM_MNS_REQUEST')
export const ADM_MNS_ENSURE =  type('ADM_MNS_ENSURE')

export const ADM_MNS_DETAIL_REQUEST =  type('ADM_MNS_DETAIL_REQUEST')
export const ADM_MNS_DETAIL_ENSURE =  type('ADM_MNS_DETAIL_ENSURE')

export const ADM_MNS_SAVE_REQUEST =  type('ADM_MNS_SAVE_REQUEST')
export const ADM_MNS_DELETE_REQUEST =  type('ADM_MNS_DELETE_REQUEST')

export const ADM_MNS_RESET_STATUS =  type('ADM_MNS_RESET_STATUS')

//////////////////////////////////////////////////////////////////
// CONTACT
/////////////////////////////////////////////////////////////////
export const ADM_CONTACT_REQUEST =  type('ADM_CONTACT_REQUEST')
export const ADM_CONTACT_ENSURE =  type('ADM_CONTACT_ENSURE')

export const ADM_CONTACT_DETAIL_REQUEST =  type('ADM_CONTACT_DETAIL_REQUEST')
export const ADM_CONTACT_DETAIL_ENSURE =  type('ADM_CONTACT_DETAIL_ENSURE')

export const ADM_CONTACT_SAVE_REQUEST =  type('ADM_CONTACT_SAVE_REQUEST')
export const ADM_CONTACT_DELETE_REQUEST =  type('ADM_CONTACT_DELETE_REQUEST')

export const ADM_CONTACT_MIN_DATE_ENSURE =  type('ADM_CONTACT_MIN_DATE_ENSURE')

export const ADM_CONTACT_RESET_STATUS =  type('ADM_CONTACT_RESET_STATUS')

export const ADM_CONTACT_ACTION_ON_SELECTION_REQUEST =  type('ADM_CONTACT_ACTION_ON_SELECTION_REQUEST')

export const ADM_CONTACT_SET_SELECTION =  type('ADM_CONTACT_SET_SELECTION')

//////////////////////////////////////////////////////////////////
// NEWSLETTER
/////////////////////////////////////////////////////////////////
export const ADM_NEWSLETTER_REQUEST =  type('ADM_NEWSLETTER_REQUEST')
export const ADM_NEWSLETTER_ENSURE =  type('ADM_NEWSLETTER_ENSURE')

export const ADM_NEWSLETTER_DETAIL_REQUEST =  type('ADM_NEWSLETTER_DETAIL_REQUEST')
export const ADM_NEWSLETTER_DETAIL_ENSURE =  type('ADM_NEWSLETTER_DETAIL_ENSURE')

export const ADM_NEWSLETTER_SAVE_REQUEST =  type('ADM_NEWSLETTER_SAVE_REQUEST')
export const ADM_NEWSLETTER_DELETE_REQUEST =  type('ADM_NEWSLETTER_DELETE_REQUEST')

export const ADM_NEWSLETTER_VALID_REQUEST =  type('ADM_NEWSLETTER_VALID_REQUEST')

export const ADM_NEWSLETTER_RESET_STATUS =  type('ADM_NEWSLETTER_RESET_STATUS')

export const ADM_NEWSLETTER_ACTION_ON_SELECTION_REQUEST =  type('ADM_NEWSLETTER_ACTION_ON_SELECTION_REQUEST')

export const ADM_NEWSLETTER_SET_SELECTION =  type('ADM_NEWSLETTER_SET_SELECTION')

//////////////////////////////////////////////////////////////////
// COURS
/////////////////////////////////////////////////////////////////
export const ADM_COURS_REQUEST =  type('ADM_COURS_REQUEST')
export const ADM_COURS_ENSURE =  type('ADM_COURS_ENSURE')

export const ADM_COURS_DETAIL_REQUEST =  type('ADM_COURS_DETAIL_REQUEST')
export const ADM_COURS_DETAIL_ENSURE =  type('ADM_COURS_DETAIL_ENSURE')

export const ADM_COURS_SAVE_REQUEST =  type('ADM_COURS_SAVE_REQUEST')
export const ADM_COURS_CREATE_REQUEST =  type('ADM_COURS_CREATE_REQUEST')
export const ADM_COURS_CREATE_RANGE_REQUEST =  type('ADM_COURS_CREATE_RANGE_REQUEST')
export const ADM_COURS_DELETE_REQUEST =  type('ADM_COURS_DELETE_REQUEST')

export const ADM_COURS_RESET_STATUS =  type('ADM_COURS_RESET_STATUS')

//////////////////////////////////////////////////////////////////
// COMMANDE
/////////////////////////////////////////////////////////////////
export const ADM_COMMANDE_REQUEST =  type('ADM_COMMANDE_REQUEST')
export const ADM_COMMANDE_ENSURE =  type('ADM_COMMANDE_ENSURE')

export const ADM_COMMANDE_DETAIL_REQUEST =  type('ADM_COMMANDE_DETAIL_REQUEST')
export const ADM_COMMANDE_DETAIL_ENSURE =  type('ADM_COMMANDE_DETAIL_ENSURE')

export const ADM_COMMANDE_SAVE_REQUEST =  type('ADM_COMMANDE_SAVE_REQUEST')
export const ADM_COMMANDE_DELETE_REQUEST =  type('ADM_COMMANDE_DELETE_REQUEST')

export const ADM_COMMANDE_MIN_DATE_ENSURE =  type('ADM_COMMANDE_MIN_DATE_ENSURE')

export const ADM_COMMANDE_RESET_STATUS =  type('ADM_COMMANDE_RESET_STATUS')

//////////////////////////////////////////////////////////////////
// FAMILY
/////////////////////////////////////////////////////////////////
export const ADM_FAMILY_REQUEST =  type('ADM_FAMILY_REQUEST')
export const ADM_FAMILY_ENSURE =  type('ADM_FAMILY_ENSURE')

export const ADM_FAMILY_DETAIL_REQUEST =  type('ADM_FAMILY_DETAIL_REQUEST')
export const ADM_FAMILY_DETAIL_ENSURE =  type('ADM_FAMILY_DETAIL_ENSURE')

export const ADM_FAMILY_SAVE_REQUEST =  type('ADM_FAMILY_SAVE_REQUEST')
export const ADM_FAMILY_DELETE_REQUEST =  type('ADM_FAMILY_DELETE_REQUEST')

export const ADM_FAMILY_RESET_STATUS =  type('ADM_FAMILY_RESET_STATUS')